export default __webpack_public_path__ + "static/media/prointegridad.bc75f850.svg";